import React from "react"
import { Modal, Tooltip } from "antd";
import './style.css'
import { IoMdArrowRoundBack } from "react-icons/io";
import { AiFillWarning } from "react-icons/ai";

const ErrorModal =({isError,message,setAPIerr})=>{

    const handlingOnClick = (query) => {
        // window.history.back() 
        setAPIerr(false)
        setTimeout(() => {
          window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        }, 1000);
      };

    return (
        <Modal visible={isError} centered={true} footer={false} closable={false} >
        <div className="errorModel">
          <AiFillWarning size={"30px"} color="#faad14" />
          <h2 style={{textAlign:'center'}}>Look Like something went wrong</h2>
          <p>
            <b>{message?.message}</b>
          </p>
          <p>Please reload the page and try again</p>
          <Tooltip title={"Go back"}>
            <div className="errorModelGoBackBtn">
              <IoMdArrowRoundBack
                size={"24px"}
                onClick={() => handlingOnClick("goBack")}
              />
            </div>
          </Tooltip>
          {/* {(!authTokenValue || WizardFlow === 6) && (
            <Tooltip title={"Go home"}>
              <div className="errorModelGoHomeBtn">
                <AiOutlineHome
                  size={"24px"}
                  onClick={() => handlingOnClick()}
                />
              </div>
            </Tooltip>
          )} */}
          <div
            className="errorModelButton"
            onClick={() => window.location.reload()}
          >
            Reload Now
          </div>
        </div>
      </Modal>
    )
}

export default ErrorModal
